module.exports = __webpack_public_path__ + "static/media/summer-of-code-logo.7ad1526c.svg";